import { client } from '@hotjar/api-base-client';

type UpdateEmailAddressesRequest = {
  accountId: number;
  emailRecipients: string[];
};

type UpdateEmailAddressesResponse = {
  success: boolean;
};

export async function updateCustomerEmailAddresses(
  request: UpdateEmailAddressesRequest,
): Promise<UpdateEmailAddressesResponse> {
  const { accountId, ...data } = request;

  return client<UpdateEmailAddressesResponse>({
    url: `/api/v1/accounts/${accountId}/email-recipients`,
    method: 'PUT',
    data,
  });
}
